import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error("Ingen session från Google.");
      nav("/logga-in", { replace: true });
      return;
    }
    googleSession(m[1])
      .then(() => {
        toast.success("Inloggad med Google");
        nav("/forum", { replace: true });
      })
      .catch(() => {
        toast.error("Kunde inte verifiera Google-sessionen.");
        nav("/logga-in", { replace: true });
      });
  }, [googleSession, nav]);

  return (
    <div className="flex items-center justify-center min-h-[40vh] flex-col gap-3">
      <Loader2 className="size-6 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Loggar in med Google…</p>
    </div>
  );
}
